import { IGetProjectUsageTableDataParams, IProjectUsageTableData } from './TranslateTableView.interfaces';

const getProjectUsageTableData = ({ projectUsages }: IGetProjectUsageTableDataParams): IProjectUsageTableData[] => {
  return projectUsages.map(
    ({
      action,
      apiKeyTitle,
      characters,
      date,
      dateLocaleDateString,
      dateLocaleTimeString,
      operations,
      referer,
      sourceLanguage,
      targetLanguage,
    }): IProjectUsageTableData => ({
      id: apiKeyTitle,
      action,
      apiKeyTitle,
      characters,
      date,
      dateLocaleDateString,
      dateLocaleTimeString,
      operations,
      referer,
      sourceLanguage,
      targetLanguage,
    }),
  );
};


export { getProjectUsageTableData };
